import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Router, NavigationStart } from '@angular/router';
import { version } from './../environments/environment.prod';
import { TranslateService } from '@ngx-translate/core';
import { SET_STORE } from './store/stateReducer';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {

  private styleGreen = 'color:white; background:#61ba96';
  private styleRed = 'color:white; background:#d36a6a';
  private styleOrange = 'color:white; background:#F29526';

  private state: any;
  private version = version;

  constructor(private store: Store<any>, private router: Router, private translate: TranslateService) {
    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang('de');

     // the lang to use, if the lang isn't available, it will use the current loader to get them
    translate.use('de');
    this.store
      .select(state => state.stateReducer)
      .subscribe(state => this.state = state);

  }

  ngOnInit() {
    console.log('%c DVS Planungshelfer %c v' + version +
                '  %c Dimitrios Kokkonias ',
                this.styleGreen, this.styleRed, this.styleOrange
    );
    this.getTranslation('de');
    this.writeLocalstorageStoreToRedux();
    console.log(this.router.url);
  }

  private getTranslation(lang) {
    fetch('/assets/i18n/' + lang + '.json', {
      mode: 'no-cors'
    })
    .then((res) => {
      return res.json();
    })
    .then( (res) => {
      this.translate.setTranslation('de', res);
    });
  }

  private writeLocalstorageStoreToRedux() {
    if (this.isStoreInLocalStorage()) {
      this.store.dispatch({type: SET_STORE, payload: JSON.parse(localStorage.getItem('redux'))});
    }
  }

  private isStoreInLocalStorage () {
    if (localStorage.getItem('redux') === null ) {
      return false;
    } else {
      return true;
    }

  }
}



// WEBPACK FOOTER //
// /Users/Dimitrios/Documents/git/dvsplanungshilfe/src/app/app.component.ts